import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StrellRoutingModule } from './strell-routing.module';
import { RouterModule } from '@angular/router';
import { IndexComponent } from './index/index.component';
import { SettingComponent } from './setting/setting.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgbPaginationModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxEditorModule } from 'ngx-editor';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';
import { SumoCodeComponent } from './sumo-code/sumo-code.component';
import {MatExpansionModule} from '@angular/material/expansion';
import { TeamComponent } from './team/team.component';
import { IntegrationsComponent } from './integrations/integrations.component';
import { AddUserModalComponent } from './add-user-modal/add-user-modal.component';
import { NgxLoadingModule } from "ngx-loading";
import { RedirectComponentComponent } from './redirect-component/redirect-component.component';
import { GoogleSearchConsoleComponent } from './google-search-console/google-search-console.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import {MatRadioModule} from '@angular/material/radio';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [IndexComponent,SettingComponent, WelcomePageComponent,SumoCodeComponent,TeamComponent, AddUserModalComponent, IntegrationsComponent, RedirectComponentComponent, GoogleSearchConsoleComponent],
  imports: [
    CommonModule,
    StrellRoutingModule,
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonToggleModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
    NgbPaginationModule,
    NgxEditorModule,
    MatMenuModule,
    MatTooltipModule,
    MatExpansionModule,
    NgxLoadingModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    NgbPopoverModule
  ]
})
export class StrellModule { }
